













































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import Table from '@/components/Table/index.vue'
import Pagination from '@/components/Pagination/index.vue'
import EnableModal from './enable-modal.vue'
import { getExportExcel } from '@/utils/export'
import { getDicts } from '@/utils/dict'
interface ParamsObject {
  current: any[number]
  size: any[number]
  [x: string]: any
}
@Component({
  components: {
    Table,
    Pagination,
    EnableModal
  }
})
export default class PeopleList extends Vue {
  $constants: any
  tabActive = ''
  whichDialog = ''
  // 字典数据
  // 居民类型
  tabData: any = []
  // 区域字典
  areaDicts: any = []
  // 批量操作 按钮 显隐控制
  batchOpt = false
  listLoading = false
  //是否清除表格勾选
  isClearChecked = false
  // 是否有表格勾选
  tableChoose = false
  tableHeader = [
    {
      key: 'name',
      name: '姓名',
      width: '6%'
    },
    {
      key: 'mobile',
      name: '手机号',
      width: ''
    },
    {
      key: 'sex',
      name: '性别',
      width: '6%',
      isSpecial: true
    },
    {
      key: 'birthday',
      name: '出生日期',
      width: '8%'
    },
    {
      key: 'nation',
      name: '民族',
      width: '6%'
    },
    {
      key: 'phase',
      name: '区域',
      width: '6%'
    },
    {
      key: 'buildingNo',
      name: '房屋',
      width: '6%',
      isSpecial: true
    },
    {
      key: 'type',
      name: '人员类型',
      width: '7%',
      isSpecial: true
    },
    {
      key: 'joinDate',
      name: '加入时间',
      width: '8%'
    },
    {
      key: 'remark',
      name: '备注',
      width: '10%',
      remark: true
    },
    {
      key: 'permitStatus',
      name: '授权状态',
      width: '7%',
      isSpecial: true
    },
    {
      key: 'opt',
      name: '操作',
      width: '10%',
      isSpecial: true
    }
  ]
  tableData: any = []
  layout = 'total, sizes, prev, pager, next, jumper'
  total = 0
  listQuery = {
    page: 1,
    limit: 15
  }
  searchModel = {
    key: 'name',
    value: null
  }
  area = ''
  status = ''
  currentHoverBtn = ''
  checkedList: any = []
  // 当前显示哪个弹窗
  currentOpenDialog = ''
  //居民类型
  jmtype: any = []

  async beforeCreate() {
    // 获取相关字典
    // 居民类型
    this.jmtype = await getDicts('DATACOLLECT_TYPE')
    this.tabData = [
      {
        name: '全部居民',
        value: ''
      },
      ...this.jmtype.slice(0, this.jmtype.length - 1)
    ]
    // 区域
    this.areaDicts = await getDicts('PHASE')
  }

  created() {
    if (this.$route.query.buildingNo) {
      this.searchModel.key = 'buildingNo'
      ;(this.searchModel.value as any) = this.$route.query.buildingNo
    }
    this.getPeopleList()
  }
  tabChange(val: string) {
    this.tabActive = val
    this.tableData = []
    this.getPeopleList()
  }
  // btn移入移出控制样式
  hoverbtn(kind: string) {
    this.currentHoverBtn = kind
  }
  defaultbtn() {
    this.currentHoverBtn = ''
  }
  //取消操作
  cancelOpt() {
    this.batchOpt = false
    this.tableChoose = false
    this.isClearChecked = false
    this.tableData.forEach((v: any) => {
      v['isChecked'] = false
      return v
    })
  }

  // 点击了哪个批量操作按钮（导出/禁用门禁）
  clickOpt(kind: string) {
    if (!this.checkedList.length) {
      this.$message.error('请选择居民')
      return
    }

    if (kind === 'door') {
      this.whichDialog = 'enable'
      this.tableChoose = true
    } else {
      this.whichDialog = ''
      this.tableChoose = true
      const ids: any = []
      this.checkedList.forEach((x: any) => {
        ids.push(x.id)
      })
      const p = {
        exportType: 'resident',
        type: this.tabActive,
        ids: ids,
        [this.searchModel.key]: this.searchModel.value
      }
      if (this.area) {
        p.phase = this.area
      }
      if (this.status == '-1' || this.status == '-2') {
        p.enable = this.status
      }

      if (this.tabActive) {
        p.type = this.tabActive
      }

      getExportExcel(p, '居民导出.xlsx')
    }
  }

  go2HouseDetail(id: any) {
    this.$router.push({
      path: '/residents/detail',
      query: {
        id: id
      }
    })
  }

  // 关闭对话框
  closeDialog() {
    this.whichDialog = ''
    this.tableChoose = false
    this.isClearChecked = false
    this.batchOpt = false
    this.checkedList = []
    this.cancelOpt()
    this.getPeopleList()
  }
  // 操作对话框后统一回调
  afterOpt() {
    const ids: any = []
    this.checkedList.forEach((x: any) => {
      if (x.enable == 1) {
        ids.push(x.id)
      }
    })
    const params = {
      enable: 2,
      residentIds: ids
    }
    if (!ids.length) {
      this.$message.error('当前无可禁用的居民')
      return
    }

    this.$api.resident
      .enableAllBatch(params)
      .then((res: any) => {
        const data = res.data
        if (data && data.success) {
          this.$message.success(data.msg)
          this.isClearChecked = true
          this.closeDialog()
        } else {
          this.isClearChecked = false
          this.$message.error(data.msg)
        }
      })
      .catch((err: any) => {
        this.$message.error(err)
      })
  }

  transferType(type: string) {
    if (this.jmtype && typeof type !== 'undefined') {
      return this.jmtype.find((v: any) => v.value == type).name
    }
  }

  // 获取当前已选
  getCheckedList(list: any) {
    this.checkedList = list
  }

  // 获取居民列表
  getPeopleList() {
    this.isClearChecked = false
    const params: ParamsObject = {
      current: this.listQuery.page,
      size: this.listQuery.limit
    }
    if (this.area) {
      params.phase = this.area
    }
    if (this.status == '1' || this.status == '2') {
      params.enable = this.status
    }
    if (this.searchModel.value) {
      //   let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      // if(this.searchModel.key=='mobile' && !reg.test(this.searchModel.value as any)){
      //     this.$message.warning('请输入合法手机号码!')
      //     return;
      // }
      params[this.searchModel.key] = this.searchModel.value
    }
    if (this.tabActive) {
      params.type = this.tabActive
    }
    this.listLoading = true
    this.$api.resident
      .getPeopleList(params)
      .then((res: any) => {
        this.tableData = []
        const data = res.data
        this.tableData = data.data.map((v: any) => {
          v['isChecked'] = false
          return v
        })
        this.checkedList = []
        this.isClearChecked = true
        this.total = data.total
        this.listLoading = false
      })
      .catch(() => {
        this.listLoading = false
      })
  }

  toEdit(data: any) {
    this.$router.push('/residents/people-edit?id=' + data.id)
  }

  doForbid(data: any) {
    this.listLoading = true
    const params = {
      residentId: data.id,
      enable: data.enable == 1 ? false : true
    }
    this.$api.resident
      .enableByResidentId(params)
      .then(() => {
        this.getPeopleList()
      })
      .catch(() => {
        this.listLoading = false
      })
  }

  //查询
  searchFn() {
    this.listQuery.page = 1
    this.listQuery.limit = 15
    this.getPeopleList()
  }
}
